import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { toast } from 'react-toastify';

const ACTION_META = {
  SUBMIT:    { label: 'Submitted',              color: '#1d4ed8', dot: '#1d4ed8' },
  RESUBMIT:  { label: 'Re-submitted',           color: '#1d4ed8', dot: '#1d4ed8' },
  SEND_BACK: { label: 'Sent back for revision', color: '#b45309', dot: '#d97706' },
  APPROVE:   { label: 'Approved',               color: '#15803d', dot: '#16a34a' },
  REJECT:    { label: 'Rejected',               color: '#b91c1c', dot: '#dc2626' },
};

function fmt(ts) {
  if (!ts) return '';
  try { return new Date(ts).toLocaleString(); } catch (_) { return String(ts); }
}

/**
 * Displays the state-transition history for a paper.
 * Props: isOpen, onClose, paperId
 */
function PaperHistoryModal({ isOpen, onClose, paperId }) {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!isOpen || !paperId) return;
    setLoading(true);
    api.get(`/qp-generation/papers/${paperId}/history`)
      .then((res) => setRows(res.data.data || []))
      .catch((err) => toast.error(err.response?.data?.message || 'Failed to load history'))
      .finally(() => setLoading(false));
  }, [isOpen, paperId]);

  if (!isOpen) return null;

  return (
    <div className="qpg-modal-backdrop" onClick={onClose}>
      <div
        className="qpg-modal"
        style={{ maxWidth: 680, width: '95%' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="qpg-modal-header">
          <div>
            <h3>Paper History</h3>
            <div className="qpg-modal-sub">Complete timeline of status changes and moderator actions.</div>
          </div>
          <button className="qpg-modal-close" onClick={onClose}>×</button>
        </div>

        <div className="qpg-modal-body" style={{ maxHeight: '72vh', overflowY: 'auto' }}>
          {loading && <div style={{ padding: 16, color: '#616161' }}>Loading...</div>}
          {!loading && rows.length === 0 && (
            <div style={{ padding: 16, color: '#616161' }}>No history recorded yet.</div>
          )}
          {!loading && rows.length > 0 && (
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {rows.map((r) => {
                const meta = ACTION_META[r.Action] || { label: r.Action, color: '#424242', dot: '#9e9e9e' };
                return (
                  <li
                    key={r.HistoryID}
                    style={{
                      display: 'flex', alignItems: 'flex-start', gap: 12,
                      padding: '12px 4px', borderBottom: '1px solid #eee',
                    }}
                  >
                    <div
                      style={{
                        width: 10, height: 10, borderRadius: '50%',
                        background: meta.dot, marginTop: 6, flexShrink: 0,
                      }}
                    />
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                        <strong style={{ color: meta.color }}>{meta.label}</strong>
                        <span style={{ fontSize: 12, color: '#616161' }}>{fmt(r.ActionAt)}</span>
                      </div>
                      <div style={{ fontSize: 13, color: '#424242', marginTop: 2 }}>
                        by <strong>{r.ActionByName || 'Unknown'}</strong>
                        {r.FromStatus && r.ToStatus && (
                          <span style={{ marginLeft: 8, color: '#757575' }}>
                            {r.FromStatus} → {r.ToStatus}
                          </span>
                        )}
                      </div>
                      {r.Note && (
                        <div
                          style={{
                            marginTop: 8, padding: 8, background: '#f7f7f7',
                            borderLeft: '3px solid #bdbdbd', fontSize: 13, whiteSpace: 'pre-wrap',
                          }}
                        >
                          {r.Note}
                        </div>
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </div>

        <div className="qpg-modal-footer">
          <button className="btn btn-outline" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

export default PaperHistoryModal;
